module.exports = __webpack_public_path__ + "static/media/advocacia-xavier-panel-logo.573eebd8.svg";